import React from 'react'
import { Button } from "antd";
import { APP_NAME } from 'configs/AppConfig';
import { Link } from 'react-router-dom'
import Flex from 'components/shared-components/Flex'
import { useSelector } from 'react-redux'
import IntlMessage from 'components/util-components/IntlMessage';

const ErrorTemplate = () => {
	const theme = useSelector(state => state.theme.currentTheme)
	return (
		<div className={`h-100 ${theme === 'light' ? 'bg-white' : ''}`}>
			<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
				<div>
					<img className="img-fluid" src={`/img/${theme === 'light' ? 'LightTheme.png': 'KowrIcon.png'}`} alt="" />
				</div>
				<div className="container">
					<div className="text-center mb-5">
						<img className="img-fluid" src="/img/others/img-21.png" alt="" />
						<h1 className="font-weight-bold mb-4">S<IntlMessage id="error.text.sorry"/></h1>
						<Link to='/app'>
							<Button type="primary"><IntlMessage id="error.text.back"/></Button>
						</Link>
					</div>
				</div>
				<Flex mobileFlex={false} justifyContent="between">
					<span><IntlMessage id="error.text.copyright"/>  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span></span>
					<div>
						<a className="text-gray" href="/#" onClick={e => e.preventDefault()}><IntlMessage id="error.text.term"/></a>
						<span className="mx-2 text-muted"> | </span>
						<a className="text-gray" href="/#" onClick={e => e.preventDefault()}><IntlMessage id="error.text.conditions"/></a>
					</div>
				</Flex>
			</div>
		</div>
	)
}

export default ErrorTemplate

